import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { fetchPVRedirectUrl, trackPVClick } from '@/services/pv';

export function usePVRedirect() {
  const { data: redirectUrl } = useQuery({
    queryKey: ['pv-redirect-url'],
    queryFn: fetchPVRedirectUrl,
    staleTime: 10 * 60_000,
  });

  const redirectToPV = useCallback((source: string) => {
    // Fire-and-forget click tracking
    trackPVClick(source);
    const url = redirectUrl || '';
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }, [redirectUrl]);

  return { redirectUrl, redirectToPV };
}
